module.exports = __webpack_public_path__ + "static/media/backgroundImage.7ad4b685.jpg";